import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * Event Types API service
 */
export const EventTypeApi = {
  /**
   * Get all event types
   * @returns {Promise<Response>} All event types response
   */
  getEventTypes: async () => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/event-types`, {
      method: 'GET',
    });
  },

  /**
   * Get event type by ID
   * @param {string|number} id - Event type ID
   * @returns {Promise<Response>} Event type response
   */
  getEventType: async (id) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/event-types/${id}`, {
      method: 'GET',
    });
  },

  /**
   * Create event type (Admin only)
   * @param {Object} data - Event type data
   * @returns {Promise<Response>} Create response
   */
  createEventType: async (data) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/event-types`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  },

  /**
   * Update event type (Admin only)
   * @param {string|number} id - Event type ID
   * @param {Object} data - Updated event type data
   * @returns {Promise<Response>} Update response
   */
  updateEventType: async (id, data) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/event-types/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  },

  /**
   * Delete event type (Admin only)
   * @param {string|number} id - Event type ID
   * @returns {Promise<Response>} Delete response
   */
  deleteEventType: async (id) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/event-types/${id}`, {
      method: 'DELETE',
    });
  },

  /**
   * Get event type metadata definitions
   * @param {string|number} eventTypeId - Event type ID
   * @returns {Promise<Response>} Metadata definitions response
   */
  getEventTypeMetadataDefinitions: async (eventTypeId) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/event-types/${eventTypeId}/metadata-definitions`, {
      method: 'GET',
    });
  },

  /**
   * Get required event type metadata definitions
   * @param {string|number} eventTypeId - Event type ID
   * @returns {Promise<Response>} Required metadata definitions response
   */
  getRequiredEventTypeMetadataDefinitions: async (eventTypeId) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/event-types/${eventTypeId}/required-metadata-definitions`, {
      method: 'GET',
    });
  },

  /**
   * Add metadata definition to event type (Admin only)
   * @param {string|number} eventTypeId - Event type ID
   * @param {Object} data - Metadata definition data
   * @returns {Promise<Response>} Add metadata definition response
   */
  addMetadataDefinitionToEventType: async (eventTypeId, data) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/event-types/${eventTypeId}/metadata-definitions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  },

  /**
   * Update event type metadata definition (Admin only)
   * @param {string|number} eventTypeId - Event type ID
   * @param {string|number} metadataDefId - Metadata definition ID
   * @param {Object} data - Updated metadata definition data
   * @returns {Promise<Response>} Update response
   */
  updateEventTypeMetadataDefinition: async (eventTypeId, metadataDefId, data) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/event-types/${eventTypeId}/metadata-definitions/${metadataDefId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  },

  /**
   * Delete event type metadata definition (Admin only)
   * @param {string|number} eventTypeId - Event type ID
   * @param {string|number} metadataDefId - Metadata definition ID
   * @returns {Promise<Response>} Delete response
   */
  deleteEventTypeMetadataDefinition: async (eventTypeId, metadataDefId) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/event-types/${eventTypeId}/metadata-definitions/${metadataDefId}`, {
      method: 'DELETE',
    });
  }
};